import styles from './style.module.scss';
import barra from '../../../assets/img/barra.png';

const HomeConfianza = () => {

    return (
        <section className={styles.container} style={{ backgroundImage: `url(${barra})` }}>
            <span className={styles.title}><strong>Con la confianza de cientos de miles de personas como tú</strong></span>
            <article className={styles['text-container']}>
                <span className={styles.text}>Con la confianza de</span>
                <span className={styles.text}>cientos de miles de</span>
                <span className={styles.text}>personas como tú</span>
            </article>
        </section>
    );
};

export default HomeConfianza;
